/**
 * 返回格式化后的时间，形如：2006-01-02 15:04:05
 * @param timestamp 时间戳 单位：秒
 * @returns string
 */
export function transformTime(timestamp: number) {
  function formatTime(str: string | number) {
    if (str < 10) {
      return '0' + str;
    }
    return str;
  }

  if (typeof timestamp === 'number') {
    const date = new Date(timestamp * 1000);
    const y: string | number = formatTime(date.getFullYear());
    const m: string | number = formatTime(date.getMonth() + 1);
    const d: string | number = formatTime(date.getDate());
    const h: string | number = formatTime(date.getHours());
    const min: string | number = formatTime(date.getMinutes());
    const sec: string | number = formatTime(date.getSeconds());

    return `${y}-${m}-${d} ${h}:${min}:${sec}`;
  }
  return '';
}